var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLamoda01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 471.2 93.8",
    style: {
      enableBackground: "new 0 0 471.2 93.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000069361505219370581090000015706690982782853308_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.1,26.3h-2.3c-4-5-10.2-7.9-16.6-7.7c-18.7,0-31.5,14.3-31.5,32.5s12.8,32.4,31.5,32.4 c8.5,0,15.2-4.4,17.6-7.7h2.3v5.9h15.7V0.4h-16.7V26.3z M357.3,67.8c-12.6,0-16.7-4.2-16.7-16.7c0-12.6,4.2-16.9,16.7-16.9 S374,38.5,374,51.1C374.1,63.7,369.9,67.8,357.3,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.7,18.6c-8.2-0.1-16.1,3.5-21.5,9.7h-2.3c-4.9-6.3-12.4-9.9-20.4-9.7c-8.9,0-16.1,4-19.9,8.5h-2.3v-6.8 h-15.7v61.3h16.7v-32c0-10.9,3.2-14.7,14.5-14.7s14.3,3.8,14.3,14.7v32H186v-32c0-10.9,3.1-14.7,14.4-14.7s14.4,3.7,14.4,14.7v32 h16.9V46.8C231.6,28.4,219.8,18.6,205.7,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.7,18.6c-20.8,0-33.7,14.3-33.7,32.5s12.9,32.4,33.7,32.4s33.7-14.1,33.7-32.4S299.5,18.6,278.7,18.6z  M278.7,67.8c-12.6,0-16.7-4.2-16.7-16.7c0-12.6,4.2-16.9,16.7-16.9s16.7,4.3,16.7,16.9S291.3,67.8,278.7,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M455.5,20.4v5.9h-2.3c-2.5-3.3-8.8-7.7-17.4-7.7c-18.7,0-31.5,14.3-31.5,32.5s12.8,32.4,31.5,32.4 c8.5,0,14.9-4.4,17.4-7.7h2.3v5.9h15.7V20.4H455.5z M438,67.8c-12.6,0-16.7-4.2-16.7-16.7c0-12.6,4.2-16.9,16.7-16.9 c12.6,0,16.7,4.3,16.7,16.9C454.8,63.7,450.6,67.8,438,67.8L438,67.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -27.9,
    y: 33.7,
    transform: "matrix(0.1219 -0.9925 0.9925 0.1219 -29.9744 50.068)",
    className: "st0",
    width: 82.5,
    height: 16.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.3,31l-0.7,5.9l-2.3-0.3c-2.1-3.6-7.8-8.7-16.3-9.8c-18.6-2.3-33,10.3-35.2,28.4s8.8,33.7,27.3,36 c8.5,1,15.3-2.5,18.2-5.5l2.3,0.3l-0.7,5.9l15.6,1.9L104,33L88.3,31z M65.2,75.9c-12.5-1.5-16.1-6.2-14.6-18.7S56.8,41,69.3,42.5 s16.1,6.3,14.6,18.8C82.3,73.8,77.7,77.4,65.2,75.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamoda01);
export default __webpack_public_path__ + "static/media/lamoda-01.6daf465236b55385650188202eb258f4.svg";
export { ForwardRef as ReactComponent };